import SubmitProposal from './SubmitProposal';
export default SubmitProposal;